import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import Allfiles from "../components/Allfiles";
import { getUploadedImages, clearUploadedImages } from './PhotoUploader/getUploadedImages';

export async function PdfGenerator(data, signatureData, staffSignatureData, policyContent = null, options = {}) {
  const { preview = false,download = false } = options;
  const doc = new jsPDF();

  
  // Use policyContent if provided, otherwise render Allfiles
  const leaseApplicationHtml = ReactDOMServer.renderToStaticMarkup(
        <Allfiles data={data} signatureData={signatureData} staffSignatureData={staffSignatureData} />
      );

  // Generate PDF as a Blob
   await new Promise((resolve) => {
    doc.html(leaseApplicationHtml, {
      callback: function(doc) {
        const totalPages = doc.internal.getNumberOfPages();
        const initials = `INITIAL: ${data.personalContact.firstName?.[0]?.toUpperCase() || ""}${data.personalContact.lastName?.[0]?.toUpperCase() || ""}`;

        // Add page numbers to each page
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          
          // Set styling
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 0);
          doc.setDrawColor(0, 0, 0);
          
          // Small square dimensions
          const boxSize = 12;
          const x = doc.internal.pageSize.width - boxSize - 10;
          const y = doc.internal.pageSize.height - boxSize - 6;

          const initBoxWidth = 20;
          const initX = 10;
          const initY = y + 5;
          
          // Draw small square border
          doc.rect(x, y, boxSize, 8);
          
          // Add centered "PG.X" text
          doc.text(
            `PG.${i}`,
            x + boxSize/2,
            y + boxSize/2,
            { 
              align: 'center',
              baseline: 'center'
            }
          );

          doc.setFont("helvetica", "bold");
          doc.text(
            initials,
            initX,
            initY,
            { baseline: 'middle', underline: true }
          );
          doc.setDrawColor(0, 0, 0);
        }
        
        // const blob = doc.output("blob");
        resolve();
      },
      margin: [20, 20, 20, 20],
      width: 170,
      windowWidth: 800,
      autoPaging: true,
    });
  });

  const uploadedImages = getUploadedImages();

  // Add images at the end of the PDF
if (uploadedImages.length > 0) {
  doc.addPage();
  let currentY = 40; // Start below top margin (20px + 20px buffer)
  let currentPage = doc.internal.getNumberOfPages();
  doc.setPage(currentPage); // Ensure we're working with the current page
  
  // Define page dimensions with margins
  const pageWidth = doc.internal.pageSize.getWidth() - 40; // 20px margins
  const usablePageHeight = doc.internal.pageSize.getHeight() - 60; // 20px top, 40px bottom
  
  for (let i = 0; i < uploadedImages.length; i++) {
    const image = uploadedImages[i];
    
    try {
      // Create a temporary image element to get original dimensions
      const img = new Image();
      img.src = image.base64 ? `data:image/jpeg;base64,${image.base64}` : image.url;
      
      await new Promise((resolve) => {
        img.onload = () => {
          // Calculate image dimensions while maintaining aspect ratio
          const imgAspectRatio = img.width / img.height;
          let displayWidth, displayHeight;
          
          // Fit to page width while maintaining aspect ratio
          displayWidth = pageWidth;
          displayHeight = pageWidth / imgAspectRatio;
          
          // Check if image fits on current page
          if (currentY + displayHeight > usablePageHeight) {
            // Doesn't fit - create new page
            doc.addPage();
            currentPage++;
            currentY = 40; // Reset Y position
          }
          
          // Center image horizontally
          const x = (doc.internal.pageSize.getWidth() - displayWidth) / 2;
          
          // Add the image
          doc.addImage(
            img.src,
            'JPEG',
            x,
            currentY,
            displayWidth,
            displayHeight,
            undefined,
            'SLOW'
          );
          
          
          // Update Y position for next image
          currentY += displayHeight + 40; // image height + caption + buffer
          
          resolve();
        };
        
        img.onerror = () => {
          console.error(`Failed to load image ${i + 1}`);
          resolve();
        };
      });
      
    } catch (error) {
      console.error(`Error adding image ${i + 1} to PDF:`, error);
    }
  }
  
  // Add page numbers to all pages (including new ones)
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    // Add your page numbering here
  }
}

  const pdfBlob = doc.output("blob");

  // Create object URL for preview
  const pdfUrl = URL.createObjectURL(pdfBlob);

  if (preview) {
    // Return the URL for preview instead of downloading
    return {
      pdfUrl,
      download: () => {
        doc.save(`FullIntakeForm_${data.firstName || 'User'}_${data.lastName || 'Document'}.pdf`);
        // Clean up the object URL after download
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
      },
      cleanup: () => URL.revokeObjectURL(pdfUrl)
    };
  }

  // Original download behavior
  if(download){
    doc.save(`FullIntakeForm_${data.firstName || 'User'}_${data.lastName || 'Document'}.pdf`);
  }  
  // Convert Blob to Base64 (for Lambda)
  const base64Pdf = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]);
    reader.readAsDataURL(pdfBlob);
  });

  // Clean up the object URL if we created it
  if (!preview) {
    URL.revokeObjectURL(pdfUrl);
  }

  return {
    base64Pdf,
    pdfBlob
  };
}